(function () {
  const overlay = document.querySelector('[data-cart-overlay]');
  const drawer = document.querySelector('[data-cart-drawer]');
  const closeBtn = document.querySelector('[data-cart-close]');
  const openBtns = document.querySelectorAll('[data-cart-open]');

  function open() {
    overlay.classList.add('open');
    drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    overlay.classList.remove('open');
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  openBtns.forEach(function (btn) { btn.addEventListener('click', open); });
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay) overlay.addEventListener('click', close);

  /* ---------- AJAX Cart helpers ---------- */

  function updateCartBadge(count) {
    var badges = document.querySelectorAll('[data-cart-count]');
    badges.forEach(function (b) {
      b.textContent = count;
      b.hidden = count < 1;
    });
  }

  function renderDrawer(cart) {
    var itemsEl = drawer.querySelector('[data-cart-items]');
    var footerEl = drawer.querySelector('[data-cart-footer]');

    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '<div class="cart-drawer-empty">Your cart is empty.</div>';
      if (footerEl) footerEl.remove();
      updateCartBadge(0);
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      var imgTag = item.image
        ? '<img class="cart-item-img" src="' + getSizedImageUrl(item.image, '150x') + '" alt="' + escHtml(item.title) + '" width="56" height="56" loading="lazy">'
        : '';

      var variantLine = item.variant_title && item.variant_title !== 'Default Title'
        ? '<div style="font-size:13px;color:rgba(157,166,181,1);margin-top:2px">' + escHtml(item.variant_title) + '</div>'
        : '';

      html += '<div class="cart-item" data-cart-item data-line-key="' + item.key + '">'
        + imgTag
        + '<div class="cart-item-info">'
        +   '<div class="cart-item-title">' + escHtml(item.product_title) + '</div>'
        +   variantLine
        +   '<div class="cart-item-price">' + formatMoney(item.final_line_price) + '</div>'
        +   '<div class="cart-item-qty">'
        +     '<button data-qty-btn data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>'
        +     '<span>' + item.quantity + '</span>'
        +     '<button data-qty-btn data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>'
        +   '</div>'
        + '</div>'
        + '<button data-remove-btn data-key="' + item.key + '" aria-label="Remove item" style="background:none;border:none;color:rgba(157,166,181,0.7);font-size:20px;cursor:pointer;padding:4px;align-self:flex-start">&times;</button>'
        + '</div>';
    });
    itemsEl.innerHTML = html;

    /* Footer */
    var existingFooter = drawer.querySelector('[data-cart-footer]');
    var footerHtml = '<div class="cart-drawer-footer" data-cart-footer>'
      + '<div class="cart-drawer-subtotal"><span>Subtotal</span><span data-cart-subtotal>' + formatMoney(cart.total_price) + '</span></div>'
      + '<a href="/checkout" class="cart-drawer-checkout">Checkout</a>'
      + '</div>';

    if (existingFooter) {
      existingFooter.outerHTML = footerHtml;
    } else {
      drawer.insertAdjacentHTML('beforeend', footerHtml);
    }

    updateCartBadge(cart.item_count);
    bindCartEvents();
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function refreshDrawer() {
    return fetchCart().then(renderDrawer);
  }

  /* ---------- Add to cart (intercept forms) ---------- */

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ajax-cart-form], form[action="/cart/add"]');
    if (!form) return;

    /* Only intercept /cart/add forms */
    var action = form.getAttribute('action');
    if (action && action.indexOf('/cart/add') === -1) return;

    e.preventDefault();

    var formData = new FormData(form);
    var btn = form.querySelector('button[type="submit"]');
    var originalHTML = btn ? btn.innerHTML : '';
    if (btn) btn.innerHTML = 'Adding&hellip;';

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        return refreshDrawer();
      })
      .then(function () {
        if (btn) {
          btn.innerHTML = 'Added!';
          setTimeout(function () {
            btn.innerHTML = originalHTML;
          }, 1200);
        }
        open();
      })
      .catch(function (err) {
        console.error('Cart add error:', err);
        if (btn) btn.innerHTML = 'Error &mdash; try again';
      });
  });

  /* ---------- Qty change & remove ---------- */

  function bindCartEvents() {
    drawer.querySelectorAll('[data-qty-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = this.getAttribute('data-key');
        var qty = parseInt(this.getAttribute('data-qty'), 10);
        changeQty(key, qty);
      });
    });

    drawer.querySelectorAll('[data-remove-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = this.getAttribute('data-key');
        changeQty(key, 0);
      });
    });
  }

  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
      credentials: 'same-origin',
    })
      .then(function (r) { return r.json(); })
      .then(renderDrawer)
      .catch(function (err) { console.error('Cart change error:', err); });
  }

  /* Bind events on initial page load (server-rendered items) */
  bindCartEvents();

  /* ---------- Utilities ---------- */

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function escHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function getSizedImageUrl(url, size) {
    if (!url) return '';
    /* Shopify image URL sizing: insert _SIZEx before extension */
    var match = url.match(/^(.+)\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i);
    if (match) return match[1] + '_' + size + '.' + match[2] + (match[3] || '');
    return url;
  }

})();
